export default {
  state: {
    list: [],
    filters: {
      country: null,
      start_date: null,
      end_date: null,
      monitor: 0,
      partner: 0,
      poll_id: null,
      monitor_name: null,
      sort: 'asc',
      page: 1
    },
    pagination: {},
    dates: [],
    result: {}
  },
  mutations: {
    setResults(state, payload) {
      state.list = payload
    },
    setResultsFilters(state, payload) {
      state.filters = payload
    },
    setResultsPagination(state, payload) {
      state.pagination = payload
    },
    setResult(state, payload) {
      state.result = payload
    },
    setDateRange(state, payload) {
      state.dates = payload
    },
    removeResult (state, id) {
      const index = state.list.findIndex(n => n.id === id)
      if (index !== -1) {
        state.list.splice(index, 1)
      }
    }
  },
  actions: {
    updateResults({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'results/rebuild-stats')
        .then(res => {
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryResults({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'results', {params: state.filters})
        .then(res => {
          commit('setResults', res.data.results)
          commit('setResultsPagination', res.data.pagination)
          commit('setDateRange', res.data.dates)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryResult({state, dispatch, commit}, result_id) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'results/' + result_id)
        .then(res => {
          commit('setResult', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    deleteResult({state, dispatch, commit}, result_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'results/' + result_id)
        .then(res => {
          commit('removeResult', result_id)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    async exportResults({state, dispatch}, lang) {
      dispatch('setPreloader', true)
      if (lang === 'select') lang = null
      let params = Object.assign(state.filters, {lang})
      try{
        const result = await axios.get(process.env.VUE_APP_API_ENDPOINT + 'export/results', {params: params})
        await dispatch('setToast', {status: 'success', message: result.data.message})
        await dispatch('setPreloader', false)
        return result
      } catch (e) {
        dispatch('setToastHttpError', error.response, {root: true})
        return false
      }
    },
  },
  getters: {
    getResults: state => {
      return state.list
    },
    getResultsFilters: state => {
      return state.filters
    },
    getResultsPagination: state => {
      return state.pagination
    },
    getResult: state => {
      return state.result
    },
    getDateRange: state => {
      return state.dates
    },
  }
}